"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoriesWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const monera_app_core_1 = require("@amzn/monera-app-core");
const core_fonts_1 = require("../core-fonts");
const merge_1 = __importDefault(require("lodash/merge"));
const StoriesWrapper = (props) => {
    const { children } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_fonts_1.CoreFonts, null),
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: (0, merge_1.default)(monera_app_core_1.moneraTheme, monera_app_core_1.coreTheme) }, children)));
};
exports.StoriesWrapper = StoriesWrapper;
